import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import moment from 'moment'
import momentLocalizer from 'react-widgets/lib/localizers/moment'
import '../styles/main.css'
import 'react-widgets/lib/less/react-widgets.less'
import 'react-select/dist/react-select.css'
import SearchScreen from './containers/searchScreen'
import Login from './containers/login'
import SearchResults from './containers/searchResults'
import GuestEntry from './containers/guestEntry'
import Dashboard from './containers/dashboard'
import Rooms from './containers/roomEditorPage'
import Payment from './containers/payment'
import BookingSuccess from './containers/bookingSuccess'
import Root from './containers/root'
import history from './history'

momentLocalizer(moment)

export default function App() {
  return (
    <Router history={history}>
      <Root>
        <Switch>
          <Route path='/' exact component={SearchScreen} />
          <Route path='/login' component={Login} />
          <Route path='/search' component={SearchScreen} />
          <Route path='/results' component={SearchResults} />
          <Route path='/guestentry' component={GuestEntry} />
          <Route path='/dashboard' component={Dashboard} />
          <Route path='/rooms' component={Rooms} />
          <Route path='/payment' component={Payment} />
          <Route path='/success' component={BookingSuccess} />
        </Switch>
      </Root>
    </Router>
  )
}



// WEBPACK FOOTER //
// ./src/App.js